export default {
  patientDetails: {},
  appointments: [],
  currentPatientAppointments: null,
  patientInfoPayload: {},
  patientMergeInfoPayload: {},
  patientAge: null,
};
